import { Component, OnInit } from '@angular/core';
import { Boat } from '../l_admin/boat.model';
import { Router } from '@angular/router';
import { BoatService } from '../services/boat.service';
import { catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs';
import { getBoatImageUrl } from '../utils/image-url.util';


@Component({
  selector: 'app-open-trip-komodo',
  templateUrl: './open-trip-komodo.component.html',
  styleUrls: ['./open-trip-komodo.component.css']
})
export class OpenTripKomodoComponent implements OnInit {

  boats: any[] = [];
  displayedBoats: Boat[] = [];
  filteredBoats: Boat[] = [];
  arrboat: any[] = [];

  displayedImages: any[] = [];
  loading = false;
  error: string | null = null;
  selectedBoat: any | null = null;
  kategori: string = 'VIP Boat';

  currentPage = 1;
  itemsPerPage = 6;

  constructor(private apiService: BoatService, private router: Router) {}


  ngOnInit(): void {
    this.displayedImages = [
      'banner_3.webp',
      'Komodo-8-scaled.webp',
      'Komodo-6-scaled.webp',
      'Komodo-3-1536x1024.webp',
      'Komodo-2-1024x683.webp',
      'Komodo-5-scaled.webp'
    ];
    this.loadBoats();
  }

  loadBoats(): void {
    this.loading = true;
    this.error = null;
  
    this.apiService
      .getBoatOpenLite('Open Trip Komodo National Park')
      .pipe(
        catchError((error) => {
          this.error = 'Failed to load boats. Please try again later.';
          console.error('Error loading boats:', error);
          return of({ items: [] }); // Mengembalikan array kosong jika terjadi error
        }),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((response) => {
        if (response && response.items) {
          this.boats = response.items;
          this.filterBoats(this.kategori); // Default: Semua boat
          this.updateDisplayedBoats();
          this.preloadCarouselImages(); // <-- Tambahkan ini
        }
      });
  }


  preloadCarouselImages(): void {
  if (typeof window === 'undefined' || !document) return;

  // Ambil gambar pertama dari setiap boat
  this.filteredBoats.forEach(boat => {
    if (boat.ms_gambarkapals && boat.ms_gambarkapals.length > 0) {
      const firstImage = boat.ms_gambarkapals[0].gambar;
      const url = getBoatImageUrl(firstImage);

      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = url;
      document.head.appendChild(link);
    }
  });
}

  filterBoats(category: string): void {
    this.kategori = category;
    this.filteredBoats = this.boats.filter(boat => boat.boat_kategori === category);
    this.displayedBoats = this.filteredBoats.slice(0, this.itemsPerPage);
  }


  getImageUrl(image: any): string {
    const imagePath = image;
    if (imagePath.startsWith('http') || imagePath.startsWith('/assets')) {
      return imagePath;
    }
    return '/assets/img/banner/' + imagePath;
  }

  getBoatImage(image: any): string {
    return getBoatImageUrl(image.gambar);
  }

  loadMore(): void {
    const currentLength = this.displayedBoats.length;
    const nextBatch = this.filteredBoats.slice(currentLength, currentLength + this.itemsPerPage);
    this.displayedBoats = [...this.displayedBoats, ...nextBatch];
  }


updateDisplayedBoats(): void {
  this.displayedBoats = this.filteredBoats.slice(0, this.itemsPerPage); // Pagination awal
}

  navigateToDetail(slug: string) {
    this.router.navigate(['/detail-boatopen', slug]);
  }
}
